import React from 'react';
import { Users } from 'lucide-react';

const PhoneTypeTabs = ({ 
  activePhoneType, 
  onPhoneTypeChange,
  personalCount = 0,
  businessCount = 0,
  dashboardCount = 0,
  showCounts = false,
  className = ''
}) => {
  const tabs = [
    { id: 'all', label: 'All' },
    { id: 'dashboard', label: 'Dashboard', count: dashboardCount, icon: Users },
    { id: 'personal', label: 'Personal', count: personalCount },
    { id: 'business', label: 'Business', count: businessCount }
  ];

  return (
    <div className={`flex gap-1 md:gap-2 ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onPhoneTypeChange(tab.id)}
          data-testid={`phone-type-tab-${tab.id}`}
          className={`flex-1 px-2 md:px-3 py-1.5 md:py-2 rounded-lg text-[10px] md:text-xs font-medium transition-all flex items-center justify-center gap-1 border ${
            activePhoneType === tab.id
              ? 'bg-white text-black border-white'
              : 'bg-black text-white border-gray-400 hover:bg-gray-900'
          }`}
        >
          {tab.icon && <tab.icon size={12} />}
          {tab.label}
          {showCounts && tab.count > 0 && (
            <span className="ml-1 text-[9px] opacity-70">({tab.count})</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default PhoneTypeTabs;
